import FormJaivana from 'dashboard_jaivana_v1';
/**
 * @description: CustomPagoAProveedores
 * @author: Anderson Acevedo
 * @version: jdesk_1.01.0007
 **/
class CustomPagoAProveedores extends FormJaivana.form {

    constructor(props) {

        super(props);
        this.initForm                                           = this.initForm.bind(this);


        this.mostrarMensajeNoHayDatos = this.mostrarMensajeNoHayDatos.bind(this);
        this.mostrarMensajeAdicional = this.mostrarMensajeAdicional.bind(this);
        this.mostrarMensajeGenerando = this.mostrarMensajeGenerando.bind(this);

        this.successConsultarCartera = this.successConsultarCartera.bind(this);
        this.consultarCartera = this.consultarCartera.bind(this);


        // Variables de tablas:
        this.gridOptionsChequesDevueltos                               = Object.assign({}, this.gridOptions);
        this.gridOptionsPagosi                               = Object.assign({}, this.gridOptions);
        this.gridOptionsPagosc                               = Object.assign({}, this.gridOptions);

        this.gridOptionsTablaDocumentos                               = Object.assign({}, this.gridOptions);
        this.onSelectionChangedTbDocumentos                          = this.onSelectionChangedTbDocumentos.bind(this);
        this.gridOptionsTablaDocumentos['onSelectionChanged'] = this.onSelectionChangedTbDocumentos;

        this.gridOptionsTablaCajas                             = Object.assign({}, this.gridOptions);
        this.onSelectionChangedTbCajas                         = this.onSelectionChangedTbCajas.bind(this);
        this.gridOptionsTablaCajas['onSelectionChanged'] = this.onSelectionChangedTbCajas;


        this.gridOptionsTablaCheques                          = Object.assign({}, this.gridOptions);
        this.onSelectionChangedTbCheques                          = this.onSelectionChangedTbCheques.bind(this);
        this.gridOptionsTablaCheques['onSelectionChanged'] = this.onSelectionChangedTbCheques;

        this.gridOptionsTablaFechas                          = Object.assign({}, this.gridOptions);

        this.gridOptionsTablaConceptos                          = Object.assign({}, this.gridOptions);
        this.onSelectionChangedTbConceptos                          = this.onSelectionChangedTbConceptos.bind(this);
        this.gridOptionsTablaConceptos['onSelectionChanged'] = this.onSelectionChangedTbConceptos;


        this.currencyFormatterGeneral = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo = this.formatNumberSaldo.bind(this);
        this.traerPropiedades = this.traerPropiedades.bind(this);
        this.sucesstraerPropiedades = this.sucesstraerPropiedades.bind(this);
        this.traerCajas = this.traerCajas.bind(this);
        this.sucesstraerCajas = this.sucesstraerCajas.bind(this);
        this.dibujarCajas = this.dibujarCajas.bind(this);
        this.calcularInteres = this.calcularInteres.bind(this);

        this.actualizar_abonos = this.actualizar_abonos.bind(this);
        this.redibujarDocumentos = this.redibujarDocumentos.bind(this);
        this.sumar_abonos = this.sumar_abonos.bind(this);
        this.actualizar_abonos = this.actualizar_abonos.bind(this);
        this.sumar_descuentos = this.sumar_descuentos.bind(this);
        this.abonar = this.abonar.bind(this);


        this.actualizar_descuentos = this.actualizar_descuentos.bind(this);
        this.procesarDescuento = this.procesarDescuento.bind(this);


        this.setButtonEliminarDoc = this.setButtonEliminarDoc.bind(this);
        this.eliminarInfoDoc = this.eliminarInfoDoc.bind(this);
        this.traerSaldoProveedor = this.traerSaldoProveedor.bind(this);
        this.successTraerSaldoProveedor = this.successTraerSaldoProveedor.bind(this);

        this.dibujarTablaConceptos = this.dibujarTablaConceptos.bind(this);
        this.eliminarConcepto = this.eliminarConcepto.bind(this);
        this.setButtonEliminarConcepto = this.setButtonEliminarConcepto.bind(this);
        this.eliminarConcepto = this.eliminarConcepto.bind(this);
        this.setButtonAgregarConcepto = this.setButtonAgregarConcepto.bind(this);
        this.agregarConcepto = this.agregarConcepto.bind(this);
        this.actualizar_conceptos = this.actualizar_conceptos.bind(this);
        this.sumar_conceptos = this.sumar_conceptos.bind(this);
        this.descontar = this.descontar.bind(this);
        this.traerConceptos = this.traerConceptos.bind(this);
        this.sucesstraerConceptos = this.sucesstraerConceptos.bind(this);
        this.ocultarCampos = this.ocultarCampos.bind(this);
        this.mostrarCampos = this.mostrarCampos.bind(this);

        this.successguardarPago = this.successguardarPago.bind(this);
        this.guardarPago = this.guardarPago.bind(this);
        this.arreglarDecimales = this.arreglarDecimales.bind(this);

        this.traerCuenta = this.traerCuenta.bind(this);
        this.traerDocumentosCartera = this.traerDocumentosCartera.bind(this);
        this.traerDocumentosOtros = this.traerDocumentosOtros.bind(this);


        //imprimir
        this.habilitarCorreo                         =this.habilitarCorreo.bind(this);
        this.deshabilitarCorreo                         =this.deshabilitarCorreo.bind(this);
        this.abrirImprimir                         =this.abrirImprimir.bind(this);
        this.isJson                         =this.isJson.bind(this);
        this.generarExcelTabla3                         =this.generarExcelTabla3.bind(this);
        this.generarPdfTabla3                         =this.generarPdfTabla3.bind(this);
        this.mostrarMensajeEmailFallo                         =this.mostrarMensajeEmailFallo.bind(this);
        this.mostrarMensajeEmailEnviado                         =this.mostrarMensajeEmailEnviado.bind(this);
        this.successEnviarCorreo                         =this.successEnviarCorreo.bind(this);
        this.enviarCorreoTerceros                         =this.enviarCorreoTerceros.bind(this);
        this.procesar                         =this.procesar.bind(this);
        this.sucessTraerDatos                         =this.sucessTraerDatos.bind(this);
        this.genearModalGlobales                         =this.genearModalGlobales.bind(this);


        this.fecha_hoy = '';
        this.array_cajas=[];
        this.array_documentos=[]; //cartera
        this.array_conceptos=[]; //otros

        this.numero=0;
        this.fecha='';
        this.codigo_sucursal='';

        this.DIAS='';
        this.DIAS_GRACIA='';
        this.TARIFA_INTERES='';
        this.TARIFA_IVA_INTERES='';
        this.fila_caja=[];
        this.fila_documento=[];
        this.fila_concepto=[];
        this.fila_cheques=[];
        this.modificando_intereses=false;
        this.VALOR_SALDO='';

        this.array_cheques=[];
        this.array_fechas=[];
        this.total_descuento=0;
        this.nombre_archivo='pagos_compras';
        this.numero_decimales_compras=2;
    }

    initForm() {
        console.log("Formulario CustomPagoAProveedores,  @version: jdesk_1.01.0007, @author: Anderson Acevedo");
        this.sucursal_ingreso = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.traerPropiedades();

        let hoy = new Date();
        let dia = hoy.getDate();
        let mes = hoy.getMonth() + 1;
        let año = hoy.getFullYear();
        if (mes < 10) {
            mes = '0' + mes;
        }
        if (dia < 10) {
            dia = '0' + dia;
        }
        this.fecha_hoy = año + '-' + mes + '-' + dia;
        this.getField('fecha_consignacion').setValue(this.fecha_hoy);
        this.getField('fecha_recibido').setValue(this.fecha_hoy);


        this.getField('consultar').setClick(this.consultarCartera);
        this.getField('nit').setOnChange(this.ocultarCampos);
        /*this.getField('select_sucursal').setOnChange(()=>{
            this.ocultarCampos();
        });*/
        this.getField('consultar').setClick(this.consultarCartera);

        this.getField('bt_seleccionar_caja').setClick(()=>{
            this.getField('modal_cajas').handleClickOpen();
            this.dibujarCajas();
            
        });

        this.getField('bt_cancelar').setClick(()=>{
            this.ocultarCampos();
            this.getField('consultar').setDisabled(false);
        });


        this.getField('bt_seleccionar').setClick(()=>{
            this.fila_caja = this.gridOptionsTablaCajas.api.getSelectedRows();
                if (this.fila_caja.length > 0) {
                    this.array_cajas.forEach((element,index)=>{
                        this.array_cajas[index].estado='.'
                        if(element.codigo.toString()===this.fila_caja[0].codigo.toString())
                            this.array_cajas[index].estado='*'
                        if(index===this.array_cajas.length-1)
                            this.getField('modal_cajas').handleClose();
                    });
                }else{
                    this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', 'error');
                }
        });

        this.getField('bt_guardar_detalle').setClick(()=>{
            if (this.fila_documento.length > 0) {
                this.guardarDetalle();
            }else{
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', 'error');
            }
        });

     

        //campos principales
        this.getField('bt_abonar').setClick(()=>{
            if (this.fila_documento.length > 0) {
                this.getField('descuento').setValue('');
                this.getField('descuento').setError(false,'');
                this.getField('descuento').setDisabled(true);

                this.getField('valor_abono').setValue(this.fila_documento[0].saldo);
                this.getField('valor_abono').setDisabled(false);
                this.getField('valor_abono').input.focus();
            }else{
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', 'error');
            }
        });

        this.getField("valor_abono").setOnBlur(() => {
            if (this.getField('valor_abono').valid())
                this.abonar();

        });

        this.getField('bt_descuento').setClick(()=>{
            if (this.fila_documento.length > 0) {
                if (this.fila_documento[0].abono !==0){
                    this.getField('valor_abono').setValue('');
                    this.getField('valor_abono').setError(false,'');
                    this.getField('valor_abono').setDisabled(true);

                    this.getField('descuento').setValue(this.fila_documento[0].descuento);
                    this.getField('descuento').setDisabled(false);
                    this.getField('descuento').input.focus();
                }else{
                    this.mostrarMensajeAdicional('Seleccione una factura e ingrese un valor de abono primero antes de aplicar un descuento');
                }
            }else{
                this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', 'error');
            }
        });

        this.getField("descuento").setOnBlur(() => {
            if (this.getField('descuento').valid()){
                //if(this.getField('descuento').getValue()>this.fila_documento[0].abono)
                this.procesarDescuento();
            }
        });


        //cargar saldo proveedor
        this.getField('bt_saldo_cliente').setClick(()=>{
            if (this.getField('nit').valid() && this.getField('sede').valid()) {
                this.traerSaldoProveedor();
            }
        });

        //conceptos

        this.getField('bt_agregar_concepto').setClick(()=>{
            this.getField('modal_conceptos').handleClickOpen();
            this.dibujarTablaConceptos();
        });

        this.getField("valor_concepto").setOnBlur(() => {
            if (this.fila_concepto.length > 0) {
                 if (this.getField('valor_concepto').valid())
                    this.descontar();
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar un concepto.', 'error');
            }
        });


        //grabar
        this.getField('bt_grabar').setClick(()=>{
            this.getField('bt_grabar').setDisabled(true);
            if(this.validarDatos()===false)
                this.getField('bt_grabar').setDisabled(false);
           
        });

        //imprimir
        this.getField('radio_correo').setValue("N");
        this.getField('generar_archivo').setClick(()=>{
            this.procesar();
        });

        //para balances globales
        this.getField('ch_excel').setOnChange((props)=>{
        if(this.getField('ch_excel').getValue()==='false'){
            this.getField('ch_pdf').setValueSwitch (false);
            this.getField('ch_pantalla').setValueSwitch (false);
            this.operacion_actual='excel';
            this.habilitarCorreo();
        }
        });
        this.getField('ch_pdf').setOnChange((props)=>{
        if(this.getField('ch_pdf').getValue()==='false'){
            this.getField('ch_excel').setValueSwitch (false);
            this.getField('ch_pantalla').setValueSwitch (false);
            this.operacion_actual='pdf';
            this.habilitarCorreo();
        }
        });
        this.getField('ch_pantalla').setOnChange((props)=>{
        if(this.getField('ch_pantalla').getValue()==='false'){
            this.getField('ch_excel').setValueSwitch (false);
            this.getField('ch_pdf').setValueSwitch (false);
            this.operacion_actual='pantalla';
            this.deshabilitarCorreo();
        }else{
            this.habilitarCorreo();
        }
        });




    }

    validarDatos(){
        if(this.getField('select_sucursal').valid() && this.getField('nit').valid() && this.getField('sede').valid() && this.getField('fecha_consignacion').valid()
        && this.getField('fecha_recibido').valid() && this.getField('cheques').valid()){
                //masdeunabono
            let count=0;
            this.array_documentos.forEach((element)=>{
                if(element.abono>0 || element.abono<0)
                    count++;
            });
            setTimeout(200);
            if(count===0){
                this.mostrarMensajeAdicional("No hay abonos a facturas.");
                return false;
            }

            //escogiounacuenta
            count=0;
            this.array_cajas.forEach((element)=>{
                if(element.estado==='*')
                    count++;
            });
            setTimeout(200)
            if(count===0){
                this.mostrarMensajeAdicional("Seleccionó varias cuentas o ninguna. Debe seleccionar sólo una."); 
                return false;
            }

            this.guardarPago();
        }else{
            this.mostrarMensajeAdicional("Hay un campo mal configurado."); 
            return false;
        }
    }

    guardarPago() {
        
        let aux=[];

        let datos = {
            datos: {
                cuenta: this.traerCuenta()+'',
                para: this.getField('fecha_consignacion').getValue(),
                cheques: this.getField('cheques').getValue(),
                nit: this.getField('nit').getValue(),
                sede: this.getField('sede').getValue(),
                concepto: 'N',
                vendedor: '0',
                temporal: '999',
                id_multicash: 0,
                codigo_sucursal: this.sucursal_ingreso,
                xsucursal: this.getField('select_sucursal').getValue(),
                fecha_recibido: this.getField('fecha_recibido').getValue(),
                documentos_cartera: this.traerDocumentosCartera(aux),
                documentos_otros: this.traerDocumentosOtros(aux),
            }
        }
        this.mostrarMensajeGuardando();
        this.generalFormatPmv = { tipo_servicio: 'comp-carteracompras', operacion: 'grabarpago', operacion_tipo: 'crear' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successguardarPago,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
    }

    successguardarPago(data) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('bt_grabar').setDisabled(false);
        if (data.estado_p === 200) {
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje','Pago guardado con consecutivo: '+data.data.numero);
            this.getField('confirmModalCustom').setClickDialog(()=>{
                try {
                    this.numero=Number(data.data.numero);
                } catch (error) {
                    this.numero=0;
                }
                this.fecha=data.data.fecha;
                this.codigo_sucursal=data.data.codigo_sucursal;
                this.getField('confirmModalCustom').toggle(false);
                this.getField('nit').setValue('');
                this.getField('sede').setValue('');
                this.getField('nombre').setValue('');
                this.getField('select_sucursal').setValue(' ');
                this.getField('modal_imprimir').setLabel("Imprimir");
                this.getField('modal_imprimir').handleClickOpen();
            });
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setButtonConfirm(`Aceptar`);
            this.getField('confirmModalCustom').toggle(true);
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    traerCuenta(){
        let valor='';
        for (var i = 0; i < this.array_cajas.length; i++) {
            if(this.array_cajas[i].estado==='*'){
                valor=this.array_cajas[i].codigo;
                break;
            }
        }
        return valor;
    }

    traerDocumentosCartera(aux){
        aux=[];
        for (var y = 0; y < this.array_documentos.length; y++) {
            if(this.array_documentos[y].abono>0 || this.array_documentos[y].abono<0)            
                aux.push(structuredClone(this.array_documentos[y]));
        }
        /////////////////////////
        for (var i = 0; i < aux.length; i++) {
            delete aux[i].dias;
            aux[i].documento=aux[i].numero;
            delete aux[i].numero;
            delete aux[i].saldo;
            delete aux[i].valor;

            aux[i].valor=aux[i].abono;   //valor = abono
            delete aux[i].abono;

            aux[i].sucursal_principal=aux[i].codigo_sucursal;
            delete aux[i].tipo;
            delete aux[i].xllave;


        }


        return aux;
    }

    traerDocumentosOtros(aux){
        aux=[];
        for (var y = 0; y < this.array_conceptos.length; y++) {
            if(this.array_conceptos[y].valor>0 || this.array_conceptos[y].valor<0)
                aux.push(structuredClone(this.array_conceptos[y]));
        }

        //retoque a campos
        for (var i = 0; i < aux.length; i++) {
            aux[i].codigo_concepto=0;
            aux[i].contable=aux[i].xcuenta;
            delete aux[i].xcuenta;
            aux[i].detalle=aux[i].xnombre;
            delete aux[i].xnombre;
            aux[i].tipo='C'; //esta se podria quitar
        }
        return aux;
    }


    traerConceptos() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: { }
        };
        this.generalFormatPmv = { tipo_servicio: 'maes-conceptospago', operacion: '1_2', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerConceptos,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerConceptos(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.array_conceptos=data.data;
            this.array_conceptos.forEach((element,index)=>{
                this.array_conceptos[index].valor=0;
            });
        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    descontar() {
        let xvalor = 0;
        if (this.fila_concepto[0].xcuenta===this.CONCEPTO_DESCUENTOS) {
            xvalor = this.getField('valor_concepto').getValue();

            if (Math.abs(xvalor) > this.total_descuento) {
                this.getField('valor_concepto').setValue(0);
                //aviso de no permitido
                this.mostrarMensajeAdicional("Valor del Descuento No PERMITIDO. Maximo " + this.total_descuento);
            } else {
                this.actualizar_conceptos(this.getField('valor_concepto').getValue(),this.fila_concepto[0].xcuenta);
            }
        } else {
            this.actualizar_conceptos(this.getField('valor_concepto').getValue(),this.fila_concepto[0].xcuenta);
        }
        this.getField('valor_total_conceptos').setValue(this.arreglarDecimales(this.sumar_conceptos()));
        this.dibujarTablaConceptos();
    }


    dibujarTablaConceptos(){
        this.getField('rejilla_conceptos').toggle(false);
        this.fila_concepto=[];
        if(this.array_conceptos.length>0){
            let configCell = new Map();
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"}});
            configCell.set('agregar', { cellRenderer: this.setButtonAgregarConcepto, sortable: false, filter: false});
            configCell.set('eliminar', { cellRenderer: this.setButtonEliminarConcepto, sortable: false, filter: false});
            this.gridOptionsTablaConceptos['rowData'] = this.array_conceptos;      
            //this.gridOptionsTablaConceptos.paginationPageSize = 5;
            this.gridOptionsTablaConceptos['paginationPageSize']=10;
            this.gridOptionsTablaConceptos['domLayout'] = 'autoHeight';// organiza el tamaño de la tabla

            this.getField('rejilla_conceptos').initData(this.gridOptionsTablaConceptos,configCell);  
        }
        this.getField('valor_concepto').setValue('');
        this.getField('valor_concepto').setDisabled(true);
        this.getField('valor_total_conceptos').setValue(this.arreglarDecimales(this.sumar_conceptos()));
        this.getField('valor_total_conceptosf').setValue(this.arreglarDecimales(this.sumar_conceptos()));
    }

    setButtonEliminarConcepto(props) {
        let button = document.createElement("input");
        button.onclick = () => this.eliminarConcepto(props.data.xcuenta);
        
        button.setAttribute("id", 'button_delete_' + props.data.xcuenta);
        button.setAttribute("class", "buttonStyle");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Eliminar");
        if (props.data.valor === 0) {
            button.setAttribute("class", "buttonDisabled");
            button.setAttribute("disabled", true);
        }
        return this.createElementJaivana(button);
    }

    eliminarConcepto(cuenta){
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar','Desea realizar esta operación?');
        this.getField('confirmModalCustom').setClickDialog(()=>{
            this.getField('confirmModalCustom').toggle(false);
            this.getField('valor_concepto').setValue(0);
            this.actualizar_conceptos(0,cuenta);
            this.getField('valor_total_conceptos').setValue(this.arreglarDecimales(this.sumar_conceptos()));
            this.dibujarTablaConceptos();
        });
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField("confirmModalCustom").setButtonConfirm(`Confirmar`);
        this.getField('confirmModalCustom').toggle(true);
    }

    setButtonAgregarConcepto(props) {
        let button = document.createElement("input");
        button.onclick = () => this.agregarConcepto(props.data);
        
        button.setAttribute("id", 'button_agregar_' + props.data.xcuenta);
        button.setAttribute("class", "buttonStyle");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Agregar");
        if (props.data.valor > 0) {
            button.setAttribute("class", "buttonDisabled");
            button.setAttribute("disabled", true);
        }
        return this.createElementJaivana(button);
    }

    agregarConcepto(data){
            this.getField('valor_concepto').setValue(data.valor);
            this.getField('valor_concepto').setDisabled(false);
            this.getField('valor_concepto').input.focus();
    }

    actualizar_conceptos(xvalor,xcuenta) {
        this.array_conceptos.forEach((element,index)=>{
            if(element.xcuenta.toString()===xcuenta.toString())
            this.array_conceptos[index].valor=xvalor;
        });
        this.actualizarTotates();
    }

    sumar_conceptos() {
        let valor=0;
        this.array_conceptos.forEach((element)=>{
            valor+=Number(element.valor);
        });
        return valor;
    }
    
    traerSaldoProveedor() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                nit : this.getField('nit').getValue(),
                sede_nit : this.getField('sede').getValue(),
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'comp-estadodecuenta', operacion: 'traertotalcarteraclientes', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successTraerSaldoProveedor,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    successTraerSaldoProveedor(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.getField('total_proveedor').setValue(data.data.total);
        } else if (data.estado_p === 404) {
            this.getField('total_proveedor').setValue(0);
            this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }


    procesarDescuento() {
        //si es un numero, quitar foco
        if (this.fila_documento.length>0) {
            //let valor_documento = this.fila_documento[0].saldo;
            let valor_descto = this.getField("descuento").getValue()
            if (valor_descto < 0) {
                this.mostrarMensajeAdicional("No se permiten descuentos negativos.");
                this.getField("descuento").setValue("0");
                return;
            }

            //if (valor_descto <= valor_documento) {
                this.actualizar_descuentos(this.getField("descuento").getValue(),this.fila_documento[0].xllave);

                this.getField('total').setValue(this.arreglarDecimales(this.sumar_abonos()));
                this.getField('total_descuento').setValue(this.arreglarDecimales(this.sumar_descuentos()));

                this.redibujarDocumentos();
            /*} else {
                this.mostrarMensajeAdicional("El Descuento es SUPERIOR AL SALDO DE LA FACTURA");
                this.getField("descuento").setValue("");
                this.getField("descuento").setDisabled(true);
                return;
            }*/
            
        } else {
            this.alertGeneral.toggle(true, 'Es necesario seleccionar un registro.', 'error');
        }
    }

    guardarDetalle(){
        this.array_documentos.forEach((element,index)=>{
            if(element.xllave.toString()===this.fila_documento[0].xllave.toString()){
                this.array_documentos[index].detalle=this.getField('detalle').getValue();
                this.getField('detalle').setValue('');
                return;
            }
        });
        setTimeout(200);
        this.redibujarDocumentos();
    }


    actualizar_descuentos(xvalor,xllave){
        this.array_documentos.forEach((element,index)=>{
            if(element.xllave.toString()===xllave.toString()){
                this.array_documentos[index].descuento=xvalor;
                return;
            }
        });
        setTimeout(200);
        this.redibujarDocumentos();
    }

    abonar(){
        if (this.fila_documento.length>0) {
            if (this.getField('valor_abono').valid()) {
                //validar el valor
                let xsaldo = this.fila_documento[0].saldo;
                let xabono = this.getField('valor_abono').getValue();
                if (Math.abs(xabono) > Math.abs(xsaldo)) {
                    this.mostrarMensajeAdicional("El abono no debe ser mayor que el saldo");
                    return;
                }
                if ((xsaldo < 0 && xabono > 0) || (xsaldo > 0 && xabono < 0)) {
                    this.mostrarMensajeAdicional("El abono no debe ser mayor que el saldo");
                    return;
                }
                //else{
                this.getField('valor_abono').setDisabled(true);
                this.actualizar_abonos(this.getField('valor_abono').getValue(),this.fila_documento[0].xllave);
                setTimeout(200);
                

                this.getField('total').setValue(this.arreglarDecimales(this.sumar_abonos()));  //total abonos
                if (xabono === 0.0) {
                    this.actualizar_descuentos(0,this.fila_documento[0].xllave);
                    this.getField('total_descuento').setValue(this.arreglarDecimales(this.sumar_descuentos()));  //total abonos
                }

                //}
                //sum de los abonos y en otra casilla
            }
        } else {
            this.mostrarMensajeAdicional("Debe seleccionar un registro");
        }
    }

    actualizar_abonos(xvalor,xllave){
        this.array_documentos.forEach((element,index)=>{
            if(element.xllave.toString()===xllave.toString()){
                this.array_documentos[index].abono=xvalor;
                this.redibujarDocumentos();
                return;
                
            }
        });
    }
    

    redibujarDocumentos(){
        this.getField('rejilla_documentos').toggle(false);
        let configCell = new Map();
        //this.fila_documento=[];
        configCell.set('abono', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.abono) }, cellStyle: {textAlign:"right"},width: 110});
        configCell.set('descuento', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.descuento) }, cellStyle: {textAlign:"right"},width: 110});
        configCell.set('sede', {cellRenderer:(props) => {return ""+props.data.sede }, cellStyle: {textAlign:"right"},width: 110});
        configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"},width: 110});
        configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo) }, cellStyle: {textAlign:"right"},width: 110});


        //configCell.set('modificar', { cellRenderer: this.setButtonModificarDistribucion, width: 110, sortable: false, filter: false, field: 'modificar' });
        configCell.set('eliminar', { cellRenderer: this.setButtonEliminarDoc, width: 110, sortable: false, filter: false, field: 'eliminar' });
        this.gridOptionsTablaDocumentos['rowData'] = this.array_documentos;      
        this.getField('rejilla_documentos').initData(this.gridOptionsTablaDocumentos,configCell);  
        this.actualizarTotates();

        this.getField('valor_abono').setValue('');
        this.getField('valor_abono').setDisabled(true);
        this.getField('descuento').setValue('');
        this.getField('descuento').setDisabled(true);
    }

    setButtonEliminarDoc(props) {
        let button = document.createElement("input");
        button.onclick = () => this.eliminarInfoDoc(props.data.xllave);
        
        button.setAttribute("id", 'button_delete_' + props.data.xllave);
        button.setAttribute("class", "buttonStyle");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Eliminar");
        if (props.data.abono === 0 && props.data.descuento===0) {
                button.setAttribute("class", "buttonDisabled");
                button.setAttribute("disabled", true);
        }
        return this.createElementJaivana(button);
    }

    eliminarInfoDoc(xllave){
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar','Desea realizar esta operación?');
        this.getField('confirmModalCustom').setClickDialog(()=>{
            this.getField('confirmModalCustom').toggle(false);
            this.getField('valor_abono').setValue(0);
            this.actualizar_abonos(0,xllave);
            this.getField('descuento').setValue(0);
            this.actualizar_descuentos(0,xllave);
            this.getField('total').setValue(this.arreglarDecimales(this.sumar_abonos()));
            this.getField('total_descuento').setValue(this.arreglarDecimales(this.sumar_descuentos()));
            this.redibujarDocumentos();
        });
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField("confirmModalCustom").setButtonConfirm(`Confirmar`);
        this.getField('confirmModalCustom').toggle(true);

    }

    actualizarTotates(){
        this.getField('total_pago').setValue(this.arreglarDecimales(this.sumar_pago()));
        
       
    }

    sumar_descuentos() {
        let xvalor = 0;
        this.array_documentos.forEach((element)=>{
            xvalor+=Number(element.descuento)
        });
        setTimeout(200);
        return xvalor;
    }

    sumarPagoMasInteres() {
        let xvalor = 0;
        this.array_documentos.forEach((element,index)=>{
            if(element.abono>0 || element.abono<0){
                xvalor+=Number(element.abono)-Number(element.retencion)+Number(element.interes)+Number(element.iva_interes);
            }
        });
        setTimeout(200); 
        this.array_conceptos.forEach((element,index)=>{
            if(element.abono>0){
                xvalor+=Number(element.xvalor);

            }
        });
        setTimeout(200);
        return xvalor;
    }


    sumar_pago(){
        let xvalor = 0;

        this.array_documentos.forEach((element,index)=>{
            if(element.abono>0 || element.abono<0){
                xvalor+=Number(element.abono)-Number(element.descuento);
            }
        });
        setTimeout(200); 

        this.array_conceptos.forEach((element,index)=>{
            if(element.valor>0 || element.valor<0){
                xvalor+=Number(element.valor);

            }
        });

        setTimeout(200);
        return xvalor;
    }

    sumar_abonos(){
        let xvalor = 0;

        this.array_documentos.forEach((element,index)=>{
            if(element.abono>0 || element.abono<0){
                xvalor+=Number(element.abono)-Number(element.descuento);

            }
        });
        setTimeout(200); 
        return xvalor;
    }

    valor_total(){
        let xvalor = 0;

        this.array_documentos.forEach((element,index)=>{
            if(element.abono>0 || element.abono<0){
                xvalor+=Number(element.abono)-Number(element.descuento);

            }
        });
        setTimeout(200); 
        this.array_conceptos.forEach((element,index)=>{
            if(element.abono>0){
                xvalor+=Number(element.xvalor);

            }
        });
        setTimeout(200);
        return xvalor;
    }

    validarAbono() {
   
        let abono =this.getField('valor_abono2').getValue();
        let interes = this.getField('valor_intereses').getValue();
        let iva = this.getField('valor_iva_interes').getValue();
        if (this.VALOR_SALDO > 0.0) {
            if (abono <= 0.0) {
                this.mostrarMensajeAdicional("Valor de abono no valido");
                return;
            }
            if (interes < 0.0 || interes > abono) {
                this.mostrarMensajeAdicional("Valor de interes no valido");
                return;
            }
            if (iva < 0.0 || iva > abono) {
                this.mostrarMensajeAdicional("Valor del iva no valido");
                return;
            }
            if (abono > this.VALOR_SALDO) {
                if (this.permitir_abono_mayor_a_saldo==='N') {
                    this.mostrarMensajeAdicional("Valor del Abono mayor al SALDO");
                    return;
                }
            }
        } else {
            if (abono > 0.0) {
                this.mostrarMensajeAdicional("Valor de abono no valido");
                return;
            }
            if (interes !== 0.0) {
                this.mostrarMensajeAdicional("Valor de interes no valido");
                return;
            }
            if (iva !== 0.0) {
                this.mostrarMensajeAdicional("Valor del iva no valido");
                return;
            }
            if (Math.abs(abono) > Math.abs(this.VALOR_SALDO)) {
                if (this.permitir_abono_mayor_a_saldo==='N') {
                    this.mostrarMensajeAdicional("Valor del Abono mayor al SALDO");
                    return;
                }
            }
        }

        this.getField('valor_abono').setValue(this.getField('total_a_pagar').getValue());
        this.abonar();
        this.getField('valor_abono').setDisabled(false);
        this.getField('valor_abono').input.focus();
        this.getField('modal_abonar').handleClose();
        
    }

    calcularInteres(){
        if(this.getField('valor_abono2').getValue()!=='' && this.getField('valor_intereses').getValue()!==''
        && this.modificando_intereses===true){
            let abono = this.getField('valor_abono2').getValue();

            let valor = 0.0, iva = 0.0;
            if (this.DIAS > this.DIAS_GRACIA) {
                valor = (this.DIAS - this.DIAS_GRACIA) * (abono * (this.TARIFA_INTERES / 100.00));
                iva = valor * (this.TARIFA_IVA_INTERES / 100.0);
            }
            this.getField('valor_intereses').setValue(valor);
            this.getField('valor_iva_interes').setValue(iva);
            this.getField('total_a_pagar').setValue(abono+valor+iva);
            this.modificando_intereses=false;
        }
    }


    traerPropiedades() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
                sucursal_ingreso: this.sucursal_ingreso
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'comp-carteracompras', operacion: 'traerpropiedades', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerPropiedades,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    sucesstraerPropiedades(data) {
        this.getField('confirmModalCustom').toggle(false);
        let opciones = [{ 'text': 'Ninguno', 'value': ' ', 'campos_cambian': {} }];
        if (data.estado_p === 200) {
            this.sucursal_principal=data.data.sucursal_principal;
            this.numero_decimales_compras=data.data.numero_decimales_compras;
            if(data.data.lista_sucursales.length>0){
                data.data.lista_sucursales.forEach(item => {
                    let dataOp = {}
                    dataOp['value'] = item.codigo
                    dataOp['text'] = item.codigo;
                    dataOp['campos_cambian'] = {  };
                    opciones.push(dataOp);
                });
            }

        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
        this.getField('select_sucursal').setOptions(opciones);

        
        this.traerCajas();
        this.traerConceptos();
    }

    traerCajas() {
        this.mostrarMensajeGenerando();
        let datos = {
            datos: {
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'maes-cuentas', operacion: '1_1', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucesstraerCajas,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });

    }

    onSelectionChangedTbDocumentos(){
        this.fila_documento = this.gridOptionsTablaDocumentos.api.getSelectedRows();
    }

    onSelectionChangedTbConceptos(){
        this.fila_concepto = this.gridOptionsTablaConceptos.api.getSelectedRows();
    }

    onSelectionChangedTbCajas(){
        this.fila_caja = this.gridOptionsTablaCajas.api.getSelectedRows();
    }

    onSelectionChangedTbCheques(){
        this.fila_cheques = this.gridOptionsTablaCheques.api.getSelectedRows();
    }

    sucesstraerCajas(data) {
        this.getField('confirmModalCustom').toggle(false);
        if (data.estado_p === 200) {
            this.array_cajas=data.data;
            this.array_cajas.forEach((element,index)=>{
                this.array_cajas[index].estado='.'
            });


        } else if (data.estado_p === 404) {
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
        }
        else {
            let respuesta = Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
        }
    }

    

    consultarCartera(){
        if(this.getField('select_sucursal').valid() && this.getField('nit').valid() && this.getField('sede').valid()){
            this.getField('consultar').setDisabled(true);
            let datos={ datos: {
                nit: this.getField("nit").getValue(),
                sede:this.getField("sede").getValue(),
                codigo_sucursal: this.getField('select_sucursal').getValue(),
                sucursal_ingreso:this.sucursal_ingreso
            } };
        
            this.generalFormatPmv = { tipo_servicio: 'comp-carteracompras', operacion: 'consultarcartera', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successConsultarCartera,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false,
            });
        }
    }

    successConsultarCartera(data){
        if (data.estado_p === 200 ){
            this.mostrarCampos();

            this.array_documentos=data.data.items;  

            for (var i = 0; i < this.array_documentos.length; i++) {
                //this.array_documentos[i].abono=0;
                //this.array_documentos[i].retencion=0;
            }
            this.redibujarDocumentos();
            let saldo=0;
            for(let i=0;i<this.array_documentos.length;i++){
                saldo+=this.array_documentos[i].saldo;
            }
            this.getField('total_pago').setValue(this.arreglarDecimales(saldo));

        }else {
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }else {
              let respuesta=Object.values(data.data.errores);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }



    dibujarCajas(){
        this.getField('rejilla_caja').toggle(false);
        let configCell = new Map();
        configCell.set('nombre', { minWidth: 1200 });
        this.gridOptionsTablaCajas['rowData'] = this.array_cajas;        
        this.getField('rejilla_caja').initData(this.gridOptionsTablaCajas,configCell);  
    }

    mostrarCampos(){
        this.getField('bt_saldo_cliente').setVisible(true);
        this.getField('bt_grabar').setVisible(true);
        this.getField('bt_cancelar').setVisible(true);
        this.getField('bt_abonar').setVisible(true);
        this.getField('bt_seleccionar_caja').setVisible(true);
        this.getField('bt_descuento').setVisible(true);
        //this.getField('bt_agregar_retencion').setVisible(true);
        this.getField('bt_agregar_concepto').setVisible(true);
        //this.getField('bt_eliminar').setVisible(true);
        
        this.getField('total_proveedor').setVisible(true);
        this.getField('detalle_proveedor').setVisible(true);
        this.getField('valor_abono').setVisible(true);
        this.getField('total').setVisible(true);
        this.getField('descuento').setVisible(true);
        this.getField('total_descuento').setVisible(true);
        this.getField('detalle').setVisible(true);
        this.getField('bt_guardar_detalle').setVisible(true);
        
        this.getField('cheques').setVisible(true);
        this.getField('total_pago').setVisible(true);
        this.getField('fecha_consignacion').setVisible(true);
        this.getField('fecha_recibido').setVisible(true);
        this.getField('valor_total_conceptosf').setVisible(true);


        
    }


    ocultarCampos(){
        this.getField('consultar').setDisabled(false);
        this.getField('rejilla_documentos').toggle(false);
        this.getField('rejilla_conceptos').toggle(false);
        this.getField('rejilla_caja').toggle(false);
        this.fila_caja=[];
        this.fila_documento=[];
        this.fila_concepto=[];
        this.array_conceptos.forEach((element,index) => {'total_descuento'
            this.array_conceptos[index].valor=0;
        });
        this.array_documentos.forEach((element,index) => {
            this.array_documentos[index].abono=0;
            this.array_documentos[index].retencion=0;
          
        });
    
        this.array_cajas.forEach((element,index)=>{
            this.array_cajas[index].estado='.';
        });
        
        this.getField('bt_saldo_cliente').setVisible(false);
        this.getField('bt_grabar').setVisible(false);
        this.getField('bt_cancelar').setVisible(false);
        this.getField('bt_abonar').setVisible(false);
        this.getField('bt_seleccionar_caja').setVisible(false);
        this.getField('bt_descuento').setVisible(false);
        //this.getField('bt_agregar_retencion').setVisible(false);
        this.getField('bt_agregar_concepto').setVisible(false);
        //this.getField('bt_eliminar').setVisible(false);

        this.getField('total_proveedor').setVisible(false);
        this.getField('detalle_proveedor').setVisible(false);
        this.getField('valor_abono').setVisible(false);
        this.getField('total').setVisible(false);
        this.getField('descuento').setVisible(false);
        this.getField('total_descuento').setVisible(false);
        this.getField('detalle').setVisible(false);
        this.getField('bt_guardar_detalle').setVisible(false);

        this.getField('cheques').setVisible(false);
        this.getField('total_pago').setVisible(false);
        this.getField('fecha_consignacion').setVisible(false);
        this.getField('fecha_recibido').setVisible(false);
        this.getField('valor_total_conceptosf').setVisible(false);

        //this.getField('cupo').setValue('');
        this.getField('total_proveedor').setValue('');
        this.getField('valor_abono').setValue('');
        this.getField('descuento').setValue('');
        this.getField('total').setValue('');
        this.getField('total_descuento').setValue('');
        this.getField('detalle').setValue('');
        this.getField('cheques').setValue('999');
        this.getField('total_pago').setValue('');
        this.getField('valor_total_conceptosf').setValue('0');
        
        this.getField('sede').setError(false,'');
        this.getField('nombre').setError(false,'');
        this.getField('total_proveedor').setError(false,'');
        this.getField('valor_abono').setError(false,'');
        this.getField('total').setError(false,'');
        this.getField('descuento').setError(false,'');
        this.getField('total_descuento').setError(false,'');
        this.getField('detalle').setError(false,'');
        this.getField('cheques').setError(false,'');
        this.getField('total_pago').setError(false,'');
        this.getField('fecha_consignacion').setError(false,'');
        this.getField('fecha_recibido').setError(false,'');
        this.getField('valor_total_conceptosf').setError(false,'');
    }
            
   

    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
          if ((decimal !== 0) && (decimal !== undefined)) {
            if(decimal.length>2){
              decimal=(Number(number).toFixed(2) + "").split(".")[1];
            }
          return (this.formatNumberSaldo(number) + "," + decimal);
          } else {
          return this.formatNumberSaldo(number); }
    }

    formatNumberSaldo(number) {
            return Number(number).toString().split('.')[0]
             .toString()
             .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

    mostrarMensajeGuardando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeAdicional(mensaje) {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', mensaje);
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setClickCancelDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog â€“ popup
        this.getField('confirmModalCustom').toggle(true);
    }

    mostrarMensajeGenerando() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
        this.getField('confirmModalCustom').setClickDialog(() => { });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);

    }

    mostrarMensajeNoHayDatos() {
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La consulta no arrojo datos.');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
    }

     //mensajes correo

    mostrarMensajeEmailEnviado(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'Email enviado exitosamente...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
      }
    
      mostrarMensajeEmailFallo(){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'Error al enviar el email...');
        this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
      }

    //modal imprimir

    deshabilitarCorreo(){
        this.getField('email').setDisabled(true);
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setDisabled(true);
        this.getField('radio_correo').setValue("N");
    }
    
    habilitarCorreo(){
        this.getField('email').setDisabled(false);
        this.getField('radio_correo').setDisabled(false);
        this.getField('radio_correo').setValue("N");
    }

    abrirImprimir(){
            
        this.getField("modal_imprimir").setLabel("Imprimir");
        this.getField('modal_imprimir').handleClickOpen();
        this.getField('email').setValue('');
        this.getField('email').setError(false,'');
        this.getField('radio_correo').setValue("N");
        this.getField('ch_excel').setValueSwitch(false);
        this.getField('ch_pdf').setValueSwitch(false);
        this.getField('ch_pantalla').setValueSwitch(false);
        this.getField('email').setDisabled(false);
  }

    procesar(){
        this.archivo_servicio='comp-carteracompras';
        let errores =0;
        if(this.getField('radio_correo').getValue()==='S' || this.operacion_actual!=='pantalla'){
            if(this.getField('email').valid()===false){
                errores++;
            }
        }
        if(this.getField('ch_excel').getValue()==='false' && this.getField('ch_pdf').getValue()==='false' && this.getField('ch_pantalla').getValue()==='false'){
            errores++;
            this.getField('ch_excel').setError(true,'* Es necesario seleccionar una opción.');
            this.getField('ch_pdf').setError(true,'* Es necesario seleccionar una opción.');
            this.getField('ch_pantalla').setError(true,'* Es necesario seleccionar una opción.');
            this.operacion_actual='';
            this.alertGeneral.toggle(true, 'Es necesario seleccionar una opción: Pdf,Excel o Pantalla.', 'error');
        }
        
        if(errores===0){
            if(this.operacion_actual!==''){
                if(this.getField('radio_correo').getValue()==='S'){
                    this.enviarCorreoTerceros();
                }else{
                    if(this.operacion_actual==='pdf'){
                        this.generarPdfTabla3();
                    }else if(this.operacion_actual==='pantalla'){
                            this.genearModalGlobales();
                    }else if(this.operacion_actual==='excel'){
                        this.generarExcelTabla3();
                    } 
                }
            }else{
                this.alertGeneral.toggle(true, 'Error al validar la operación.', 'error');
                this.getField('confirmModalCustom').toggle(false);
            } 
        }
    }

    genearModalGlobales(){
        this.mostrarMensajeGenerando();
        let datos={datos:{
            sucursal_ingreso: this.sucursal_ingreso,
            operacion : this.operacion_actual,
            email : this.getField('email').getValue(),
            radio_correo : this.getField('radio_correo').getValue(),
            numero : this.numero,
            fecha : this.fecha,
            codigo_sucursal: this.codigo_sucursal
        }}

        this.generalFormatPmv = { tipo_servicio: 'comp-carteracompras', operacion: 'imprimir', operacion_tipo: 'consulta' };
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.sucessTraerDatos,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
  }

  sucessTraerDatos(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){ 
            let datosFicha = [];
            this.lista=data.data.datos_lista;

            let data2 = 
                {
                    "empresa": this.lista.empresa,
                    "razon_social": this.lista.razon_social,
                    "nit": this.lista.nit,
                    "ciudad": this.lista.ciudad,
                    "telefono": this.lista.telefono,
                    "direccion": this.lista.direccion,
                    "titulo": this.lista.titulo,
                    "sucursal": this.lista.sucursal,
                    "nsucursal": this.lista.nsucursal,
                    "fecha_pago":this.lista.fecha_pago,
                    "beneficiario":this.lista.beneficiario,
                    "paguese_el":this.lista.paguese_el,
                    "cuenta":this.lista.cuenta,
                    "cheque_nro":this.lista.cheque_nro==='999'?'':this.lista.cheque_nro, // hay una cpondición en el jasper para que solo lo muestre cuando sea diferete 999
                };

            datosFicha.push(data2);
            this.getField('lista_datos').setItemsFichas(datosFicha);

            this.getField('modal_result').setLabel('Pago No '+this.numero);
            this.getField('modal_result').handleClickOpen();

            this.getField('rejillapagosi').toggle(true);

            this.gridOptionsPagosi['rowData'] = [];
            let configCell = new Map();
            this.gridOptionsPagosi['rowData'] = data.data.pagosi;
            //con ubicacion-->codigo,xnombre,alias,ubicacion_bodega,cantidad,subtota1,tarifa_iva,valor_iva,valor_item
            configCell.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"}});
            configCell.set('descuento', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.descuento) }, cellStyle: {textAlign:"right"}});

            this.getField('rejillapagosi').initData(this.gridOptionsPagosi,configCell);

            if(data.data.pagosi!==undefined && data.data.pagosi.length>0){
                this.getField('rejillapagosc').toggle(true);
                this.gridOptionsPagosc['rowData'] = [];
                let configCell2 = new Map();
                this.gridOptionsPagosc['rowData'] = data.data.pagosc;
                //con ubicacion-->codigo,xnombre,alias,ubicacion_bodega,cantidad,subtota1,tarifa_iva,valor_iva,valor_item
                configCell2.set('valor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.valor) }, cellStyle: {textAlign:"right"}});
                this.getField('rejillapagosc').initData(this.gridOptionsPagosc,configCell2);
            }else{
                this.getField('rejillapagosc').toggle(false);
            }

    
            //this.getField('detalle_info').setValue(this.lista.detalle);

            this.getField('valor_facturas2').setValue(this.arreglarDecimales(this.lista.valor_facturas));
            this.getField('valor_descuentos').setValue(this.arreglarDecimales(this.lista.valor_desctos));
            this.getField('valor_anexos2').setValue(this.arreglarDecimales(this.lista.valor_anexos));
            this.getField('valor_total_pago').setValue(this.arreglarDecimales(this.lista.valor_total));

      }else if(data.estado_p === 404){
            this.getField('rejillapagosi').toggle(false);
            this.getField('rejillapagosc').toggle(false);
            //this.alertGeneral.toggle(true, 'La consulta no arrojo datos.', 'error');
            this.mostrarMensajeNoHayDatos();
      }
      else{
            this.getField('rejillapagosi').toggle(false);
            this.getField('rejillapagosc').toggle(false);
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
      } 
  }


    enviarCorreoTerceros(){
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        let datos={datos:{
            sucursal_ingreso: this.sucursal_ingreso,
            operacion : this.operacion_actual,
            email : this.getField('email').getValue(),
            radio_correo : this.getField('radio_correo').getValue(),
            numero : this.numero,
            fecha : this.fecha,
            codigo_sucursal: this.codigo_sucursal
        }}
        this.generalFormatPmv = { tipo_servicio: 'comp-carteracompras', operacion: 'imprimir', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successEnviarCorreo,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });
  }
  
  successEnviarCorreo(data){
      this.getField('confirmModalCustom').toggle(false);
      if(data.estado_p === 200){
          this.mostrarMensajeEmailEnviado();
      }else if(data.estado_p === 404){
        this.mostrarMensajeNoHayDatos();
      }else{
          this.mostrarMensajeEmailFallo();
          let respuesta=Object.values(data.data.errores);
          this.alertGeneral.toggle(true, 'Error ' + respuesta, 'error');
      }
  }

  generarPdfTabla3()
    {       
      this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
      this.getField('confirmModalCustom').setClickDialog(()=>{});  
      this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
      this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
      this.getField('confirmModalCustom').toggle(true);
            let url = this.constant.formConfiguration();
            let datos2={
                sucursal_ingreso: this.sucursal_ingreso,
                operacion : this.operacion_actual,
                email : this.getField('email').getValue(),
                radio_correo : this.getField('radio_correo').getValue(),
                numero : this.numero,
                fecha : this.fecha,
                codigo_sucursal: this.codigo_sucursal
            }

            const myJSON = JSON.stringify(datos2);
            let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"comp-carteracompras","operacion":"imprimir","operacion_tipo":"consulta"}}';
            fetch(url+datos,{
            method:'GET', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'})})
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
            return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const pdf = new File([blob], this.nombre_archivo+'.pdf', {
                                type:'application/pdf'});
                            window.open(URL.createObjectURL(pdf));
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
              this.alertGeneral.toggle(true,err,'error');
            });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    generarExcelTabla3()
    {
      this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está guardando la información... `);
      this.getField('confirmModalCustom').setClickDialog(()=>{});  
      this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
      this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
      this.getField('confirmModalCustom').toggle(true);
            let url = this.constant.formConfiguration();
            let datos2={
                sucursal_ingreso: this.sucursal_ingreso,
                operacion : this.operacion_actual,
                email : this.getField('email').getValue(),
                radio_correo : this.getField('radio_correo').getValue(),
                numero : this.numero,
                fecha : this.fecha,
                codigo_sucursal: this.codigo_sucursal
            }

            const myJSON = JSON.stringify(datos2);
            let datos='?body={"datos":'+myJSON+',"generales":{"tipo_servicio":"comp-carteracompras","operacion":"imprimir","operacion_tipo":"consulta"}}';
            fetch(url+datos,{
            method:'GET', 
            headers:new Headers({
                    "Authorization": 'Bearer '+localStorage.getItem('token'), 
                    "Content-Type":'application/json'})})
            .then(response => {
            this.getField('confirmModalCustom').toggle(false);
            if(response.status!==200){
                return '';
            }
            const reader = response.body.getReader();
            return new ReadableStream({
            start(controller) {
            return pump();
            function pump() {
                    return reader.read().then(({ done, value }) => {
                    if (done) {
                        controller.close();
                        return;}
                    controller.enqueue(value);
                    return pump();});}}})})
            .then(stream => new Response(stream))
            .then(response => response.blob())
            .then(blob => {
                if(blob.size>0){
                    blob.text().then(res=>{
                        if(this.isJson(res)){
                            this.successEnviarCorreo(JSON.parse(res));
                        }else{
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.style.display = 'none';
                            a.href = url;
                            // the filename you want
                            a.download = this.nombre_archivo+'.xlsx';
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            alert('Se descargo el archivo!');
                        } 
                    });
                }else{
                    this.mostrarMensajeNoHayDatos();
                }
            }).catch(err => {
                this.alertGeneral.toggle(true,err,'error');
            });
    }

    arreglarDecimales(numero){
        let numero_valor=Number(numero);
        let decimales=numero_valor.toString().split('.')[1];
        if(decimales!==undefined && decimales.length>2){
            numero_valor=numero_valor.toFixed(this.numero_decimales_compras);
        }
        return numero_valor;
    }


}
FormJaivana.addController("comp-carteracompras", CustomPagoAProveedores);
export default CustomPagoAProveedores;